import {gql} from "@apollo/client";
import {Organization} from "@App/types";

export interface GarageListQuery {
    organization: Organization
}

export const GET_GARAGE_LIST = gql`
    query getGarageList(
        $id: ID,
        $organization:ID!,
        $lat:Float,
        $lon:Float,
        $distance:Int,
        $appointmentsFrom: DateTimeTz,
        $appointmentsTo: DateTimeTz,
        $services: [ID],
        $search: String,
        $sortBy: String,
        $premiumServices: [ID],
        $slug: String,
        $offset: Int,
        $limit: Int,
        $brand: ID,
        $generation: ID,
        $motorization: ID,
        $gearbox: ID,
        $body: ID,
        $mileage: Int,
        $registrationDate: Date,
        $subRepairs: [String],
        $equipments: [String],
        $withCalculation: Boolean!,
        $supportsBev: Boolean,
        $supportsCommercialVehicles: Boolean,
        $onlyBookable: Boolean,
        $driverID: UUID,
        $garageTypes: [ID]
        $garageChains: [ID]) {
        organization(id: $organization) {
            id
            uuid
            calculation(
                input: {
                    services: $services
                    brand: $brand
                    generation: $generation
                    motorization: $motorization
                    mileage: $mileage
                    gearbox: $gearbox
                    body: $body
                    registration_date: $registrationDate
                    sub_repairs: $subRepairs
                    equipments: $equipments
                }
            )  @include(if: $withCalculation) {
                labour_steps {name}
                parts {name}
            }
            garages(
                id: $id,
                lat: $lat,
                lon: $lon,
                distance: $distance,
                appointmentsFrom: $appointmentsFrom,
                appointmentsTo: $appointmentsTo,
                search: $search,
                sortBy: $sortBy,
                services: $services,
                premiumServices: $premiumServices,
                slug: $slug,
                offset: $offset,
                limit: $limit,
                brand: $brand,
                garageTypes: $garageTypes,
                calculation: {
                    services: $services,
                    brand: $brand,
                    generation: $generation,
                    motorization: $motorization,
                    mileage: $mileage,
                    gearbox: $gearbox,
                    body: $body,
                    registration_date: $registrationDate,
                    sub_repairs: $subRepairs,
                    equipments: $equipments,
                },
                supportsBev: $supportsBev,
                supportsCommercialVehicles: $supportsCommercialVehicles,
                onlyBookable: $onlyBookable,
                garageChains: $garageChains,
                driver: $driverID
            ){
                data {
                    id
                    uuid
                    name
                    slug
                    distance
                    travel_time
                    lat
                    lon
                    rating
                    review_count
                    street
                    cover_image
                    city
                    postcode
                    phone
                    garageType {
                        name
                        display_name_singular
                    }
                    nationwide_service
                    authorizedBrands {
                        id
                        name
                    }
                    calculation @include(if: $withCalculation) {
                        estimated_price
                        estimated_price_before_promotion
                        parts_price
                        promotion {
                            description
                            gross_discount
                            formatted_discount_type
                            type
                            discount_prefix
                            bonuses {
                                icon
                                name
                                description
                            }
                        }
                    }
                    available_days(services: $services) {
                        id
                        available_at
                    }
                    premium_services(services: $services) {
                        id
                        name
                        paid
                        filterable
                        show_in_list
                        type
                    }
                    checkpoint {
                        id
                        name
                        logo
                    }
                    pivot {
                        bookable
                        preferred_partner
                    }
                    liveBookable(services: $services)
                    drivingLicenseCheckpoint {
                        name
                    }
                    billingGroups {
                        display_name
                    }
                }
                paginatorInfo {
                    hasMorePages
                }
            }
        }
    }
`;
